import '../scss/main.scss';

import Flickity from 'flickity';
import 'flickity/dist/flickity.css';

window.addEventListener('DOMContentLoaded', function() {
	let projectCarouselContainers = document.querySelectorAll('.module-project-carousel-carousel-container');

	if (projectCarouselContainers.length < 1) {
		return;
	}

	// TODO: what is this?
	this.flickity = null;

	projectCarouselContainers = [].slice.call(projectCarouselContainers);

	projectCarouselContainers.forEach(container => {
		// TODO: when there are multiple?
		this.flickity = new Flickity(container, {
			contain: true,
			pageDots: false,
			//draggable: false,
			prevNextButtons: true,
			cellSelector: '.project-carousel-project-container',
			cellAlign: 'left'
		});
	});

	// TODO: when there are multiple?
	this.flickity.on('staticClick', (event, pointer, cellElement, cellIndex) => {
		if (!cellElement) {
			return;
		}

		this.flickity.select(cellIndex);
	});

	// TODO: needs more testings
	document.addEventListener('keyup', (e) => {
		if (e.key != 'Enter') {
			return;
		}
		// TODO: when there are multiple?
		window.location = this.flickity.selectedElement.querySelector('a').getAttribute('href');
	})
});